//import logo from './logo.svg';
//import './App.css';
import Prodotto from './Product.jsx';
import products from './products.js'

function App() {
  
  return (
    <div className='App'>
      <h2>La nostra prima card</h2>
      <section className='card-section'>        
        {
          products.map((prodotto) => { //
            //1° metodo sconsigliato map(prodotto, index) e poi mettere key={index}, 
            // 2° metodo mettere id nei singoli elementi dell'array e poi mettere key={prodotto.id}
           // 3° metodo: const {id} = prodotto    e poi: return  <Prodotto key={id} {...prodotto} />
           // console.log(prodotto);
            // return <Prodotto {...prodotto}/>;
           // return <Product prodotto={prodotto}/> //usa qurllo importato
           const {id} = prodotto
             return  <Prodotto key={id} {...prodotto} />
          })
        }
      </section>   
    </div> 
  );
}
//possiamo destrutturare l'oggetto direttamente nel passaggio dei parametri
// const Prodotto = ({costoFinale, nome, img , prezzo, children}) => {
//   //metodo per destrutturare
//  // const {costoFinale, nome, img , prezzo} = props;
//  // console.log(props);
//   // console.log(props.nome);
//   // const alt = 'valore';
//   // const prezzo = '14,00';

//   return (
//     <article>
//       <div className='card'>
//         <img src={img}  alt={`${nome}`} />
//           {/* <img src={props.img}  alt={`${props.nome}`} /> */}
//         <h6>{nome}</h6>
//          {/* <h6>{props.nome}</h6> */}
//           {/* <h6>10€ Amazon + 20P</h6> */}
//         <hr/>
//           <p>{prezzo}</p> 
//            {/* <p>{props.prezzo}</p> */}
//           {/* <p>{props.nome}</p>
//           <p>{props.numero}</p> */}
//           <p>bamby000</p>
//           <p>{children}</p>
//           {/* <!-- <p style={{textTransform: "uppercase"}} --> */}
             
//       </div>    
//       <p className='card-time'>{children}</p>  
//           <button>
//             {costoFinale}€
//              {/* {props.costoFinale}€ */}
//           </button>         
//     </article>
//   )
// }

export default App;


 // <div className="App">
    //   <header className="App-header">
    //     <img src={logo} className="App-logo" alt="logo" />
    //     <p>
    //       Ciao sono un'app
    //     </p>
    //     <a
    //       className="App-link"
    //       href="https://reactjs.org"
    //       target="_blank"
    //       rel="noopener noreferrer"
    //     >
    //       Learn React
    //     </a>
    //   </header>
    // </div>
